import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-snapshot-chartsparent',
  templateUrl: './snapshot-chartsparent.component.html',
  styleUrls: ['./snapshot-chartsparent.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})



export class SnapshotChartsparentComponent {
  @Input() brandSelected:any="";//only for trendline 2 set up for custom snapshot
  @Input() metricSelected:any=""; //only for trendline 2 set up for custom snapshot
  @Input() gridTempleteColumns:any;
  @Input() isOutput=false;
  @Input() chart: any = '';
  @Input() id: number | undefined;
  @Input() height: any;
  @Input() data: any;
  @Input() customData: any;
  @Input() popUp: any;
  @Input() WidgetDetails: any;
  @Input() sort: any;
  @Input() Top10Toggle: any;
  @Input() DataLabelOn: any;
  @Input() snapProduct:string='';
  @Input() widgetCount:any;
  @Input() enableDataBars: boolean = false;
  @Input() widgetName: string = '';
  @Input() layoutWidth!: number;
  @Input() globalColorMap: { [key: string]: string } = {};
  @Input() showLegend: boolean = true;
  snapProductisCustom: boolean = false;
  hasLineChartData: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['snapProduct']) {
      this.snapProductisCustom = this.snapProduct === 'custom';
    }
    if (changes['customData']) {
      this.hasLineChartData =
        this.customData?.metric?.length > 0 &&
        this.customData.metric[0]?.metric_value?.length > 0 &&
        this.customData.noData !== true;
    }
  }

}
